import { DisclosureFilter } from "../disclosureFilter/DisclosureFilter.tsx";
import useEmblaCarousel from "embla-carousel-react";
import { useAppSelector } from "../../../../../../stores/hooks/hooks.ts";
import { RevPersonaCard } from "@revmatics/catalyst";
import { usePrevNextButtons } from "../../../../../../helpers/hooks/usePrevNextButtons.ts";
import {
  PrevButton,
  NextButton,
} from "./components/carouselArrowsBtn/CarouselArrowsBtn.tsx";
import { useEffect } from "react";
import { Link } from "react-router";
import { getParamsName } from "../../../../../../helpers/paramsName/paramsName.ts";

export const PersonaDisclosureFilter = () => {
  const personas = useAppSelector((state) => state.personas.personas);
  const selectedPersona = useAppSelector(
    (state) => state.discoverCommunities.selectedPersona,
  );

  const [emblaRef, emblaApi] = useEmblaCarousel({});

  useEffect(() => {
    if (emblaApi) {
      emblaApi.reInit();
      emblaApi?.scrollTo(0, false);
    }
  }, [emblaApi, selectedPersona]);

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  // This wrapper provides the react-router Link context to the Catalyst card.
  const PersonaLink = ({
    children,
    personaId,
  }: {
    children: React.ReactNode;
    personaId: number;
  }) => (
    <Link to={{ search: `?${getParamsName.persona}=${personaId}` }}>
      {children}
    </Link>
  );

  if (personas && selectedPersona) {
    return (
      <DisclosureFilter
        title="Buyer Persona"
        tooltip="Select a single persona"
        selectedList={[selectedPersona.name]}
      >
        <div className="pt-0.5">
          <div
            className="embla relative p-2 rounded-lg bg-monochrome-910"
            ref={emblaRef}
          >
            <div className="embla__container flex gap-3 px-0.5">
              <div className="embla__slide" data-testid="selected-persona-card">
                <RevPersonaCard
                  persona={selectedPersona}
                  selected
                  LinkWrapper={PersonaLink}
                />
              </div>
              {personas.map(
                (persona) =>
                  persona.id !== selectedPersona.id && (
                    <div
                      className="embla__slide"
                      data-testid="persona-card"
                      key={`persona-discover-community-${persona.id}-${persona.name}`}
                    >
                      <RevPersonaCard
                        persona={persona}
                        disabled={persona.interests.length === 0}
                        LinkWrapper={PersonaLink}
                      />
                    </div>
                  ),
              )}
            </div>
            <PrevButton
              onClick={onPrevButtonClick}
              disabled={prevBtnDisabled}
            />
            <NextButton
              onClick={onNextButtonClick}
              disabled={nextBtnDisabled}
            />
          </div>
        </div>
      </DisclosureFilter>
    );
  }
  return null;
};
